import api from '../api';
import { IChatCrypt, IEncryptedChatMessage } from '../types/api/chat/chatCrypt';

export const encryptChatMessage = (nursingHomeId: number, text: string): Promise<IEncryptedChatMessage> =>
  api.post(`/nursing-homes/${nursingHomeId}/chats/encrypt`, { text });

export const decryptChatMessages = (
  nursingHomeId: number,
  messages: IChatCrypt[],
): Promise<IChatCrypt[]> => api.post(`/nursing-homes/${nursingHomeId}/chats/decrypt`, messages);
